<div class="guest-carousel-container">
    <div class="guest-carousel-content" [ngStyle]="{'height': containerHeight + 'px'}">

      <owl-carousel-o [options]="carouselOptions" class="carousel-container" >
        <ng-container *ngFor="let card of cardList" class="carousel-items">
          <ng-template carouselSlide>
            <div class="card">
              <div class="image-container">
                <img  id="carousel" [src]="'https:' + card.fields.cardImage.fields.file.url" alt="card-image">
                <span class="card-desc">{{card?.fields.cardTitle}}</span>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>

    </div>
</div>
